import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { initialProducerState } from 'store/producer/initial.ts'
import { deleteExtraImage, getContracts, getProducer, getProducers, uploadImages } from 'store/producer/thunks'
import { getProducersTransformer } from 'store/producer/transformers'
import { ProducerImageTypes } from 'store/producer/types.ts'

export const producerSlice = createSlice({
  name: 'producer',
  initialState: initialProducerState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(getProducers.fulfilled, (state, { payload }) => {
      return getProducersTransformer({ ...payload, state })
    })
    builder.addCase(getProducer.fulfilled, (state, { payload }) => {
      state.producer = payload.producer
    })
    builder.addCase(uploadImages.fulfilled, (state, { payload }) => {
      const profileImg = payload.urls.find((url) => url.includes('/profile'))
      const headerImg = payload.urls.find((url) => url.includes('/header'))
      const logoImg = payload.urls.find((url) => url.includes('/logo'))
      const extraImages = payload.urls.filter((url) => !url.includes('/profile') && !url.includes('/header'))

      switch (payload.fieldName) {
        case ProducerImageTypes.PROFILE:
          if (state?.producer?.images.profile) state.producer.images.profile.url = profileImg
          break

        case ProducerImageTypes.HEADER:
          if (state?.producer?.images.header) state.producer.images.header.url = headerImg
          break

        case ProducerImageTypes.LOGO:
          if (state?.producer?.images.logo) state.producer.images.logo.url = logoImg
          break

        case ProducerImageTypes.EXTRA:
          if (state?.producer?.images.extra) state.producer.images.extra.push(...extraImages.map((url) => ({ url })))
          break
      }
    })
    builder.addCase(getContracts.fulfilled, (state, { payload }) => {
      state.contracts = payload.contracts
    })
    builder.addCase(deleteExtraImage.fulfilled, (state, { payload }) => {
      if (state?.producer?.images?.extra) {
        state.producer.images.extra = state.producer.images.extra?.filter((image) => image.url !== payload.url)
      }
    })

    // IS PENDING MATCHER
    builder.addMatcher(isPending(getProducers, uploadImages, getContracts, deleteExtraImage), (state) => {
      state.loading = true
      state.error = false
    })

    // IS FULFILLED
    builder.addMatcher(isFulfilled(getProducers, uploadImages, getContracts, deleteExtraImage), (state) => {
      state.loading = false
      state.error = false
    })

    // IS REJECTED
    builder.addMatcher(isRejected(getProducers, uploadImages, getContracts, deleteExtraImage), (state) => {
      state.loading = false
      state.error = true
    })
  }
})

export default producerSlice.reducer
